import React, { Component } from 'react'
// import { Tabs } from 'antd';
import img1 from '../../../static/images/unattended-banner.jpg'
import product1 from '../../../static/images/product-1.png'
import product3 from '../../../static/images/product-3.png'

import unattended1 from '../../../static/images/unattended1.png'

import step1 from '../../../static/images/step1.png'

import advantage2 from '../../../static/images/advantage2.png'
import advantage3 from '../../../static/images/advantage3.png'
import advantage4 from '../../../static/images/advantage4.png'
import advantage5 from '../../../static/images/advantage5.png'

import intelligent1 from '../../../static/images/intelligent1.png'



import './index.less';
// const { TabPane } = Tabs;
class Unattended extends Component {
    state = {
        iframeHeight: 600,
        customerList: [
            { img: product1, title: '安卓收银机' },
            { img: product1, title: 'PC管理后台' },
            { img: product1, title: '自主收银机' },
            { img: product1, title: '智能POS机' },
            { img: product1, title: 'APP端' },
        ],
        partnerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
    }

    componentDidMount() {
        this._onUnattendedIframeMessage = (e) => {
            const d = e.data
            if (!d || d.source !== 'unattended-iframe' || typeof d.height !== 'number') return
            if (d.height < 200) return
            this.setState({ iframeHeight: d.height })
        }
        window.addEventListener('message', this._onUnattendedIframeMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onUnattendedIframeMessage)
    }

    syncIframeHeightFromContent = (iframe) => {
        if (!iframe) return
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document
            const h = Math.max(
                doc.documentElement.scrollHeight,
                doc.body.scrollHeight,
                doc.documentElement.offsetHeight,
                doc.body.offsetHeight
            )
            if (h > 200) {
                this.setState({ iframeHeight: h })
            }
        } catch (err) {
            // cross-origin: rely on postMessage from unattended.html
        }
    }

    onEvents() { }
    render() {
        const { iframeHeight } = this.state
        return (
            <div style={{ width: '100%' }}>
                 <iframe 
                 title="unattended-static"
                 src={`${process.env.PUBLIC_URL}/static/unattended/unattended.html`}
                style={{ width: '100%', height: iframeHeight, border: 'none', display: 'block', overflow: 'hidden' }}
                onLoad={(e) => this.syncIframeHeightFromContent(e.target)}
                />
            </div>
            // <div className="product_container unattended-container">
            //     <div className="top-home-carousel">
            //         <div className="banner-bg"><img className="banner-img" src={img1} alt="" /></div>
            //         <div className="mode-mark"></div>
            //         <div className="mask-top-content">
            //             <div className="content-pos">
            //                 <div className="content-left-text">
            //                     <div className="banner-top-title">悦喵AI-24H无人零售</div>
            //                     <div className="banner-top-tips">使用多维感知技术，实现线下门店/仓库“人、货、场”的数字孪生，重塑行业经营，重塑社会生活</div>
            //                     <div className="banner-top-btn">了解体验</div>
            //                 </div>
                            
            //             </div>
                        
            //         </div>
            //     </div>

            //     <div className="common-block-home unattended-first">
            //         <div className="common-block-home-title">首创 有人+无人模式 让店铺24小时营业</div>
            //         <div className="common-block-product">
            //             <div className="store-model">
            //                 <div className="store-model-title">白天“有人模式”</div>
            //                 <div className="store-model-tips">店员/导购员正常营业收银</div>
            //                 <img className="unattended-img-style" src={unattended1} alt="" />
            //             </div>
            //             <div className="store-model">
            //                 <div className="store-model-title">夜间“无人模式”</div>
            //                 <div className="store-model-tips">店内无人智能收银</div>
            //                 <img className="unattended-img-style" src={unattended1} alt="" />
            //             </div>
            //         </div>
            //     </div>


            //     <div className="common-block-home product-page">
            //         <div className="common-block-home-title">无人模式” 购物只需4步</div>
            //         <div className="common-block-home-title">0门槛的无人购物体验</div>
            //         <div className="common-block-product">
            //             <div className="product-detail product-detail-page unattended-first-page">
            //                 <div className="first-page-title">
            //                     <span className="first-page-title-left">第1步</span>
            //                     <span className="first-page-title-right">耗时5S</span>
            //                 </div>
            //                 <img className="product-detail-img" src={step1} alt="" />
                            
            //                 <div className="product-detail-title">验证进店</div>
            //                 <div className="product-detail-tips" style={{ color: '#ff5b33'}}>微信扫码/人脸识别开门</div>
            //                 <div className="product-detail-tips">自动成为门店会员</div>
            //             </div>
            //             <div className="product-detail product-detail-page unattended-first-page">
            //                 <div className="first-page-title">
            //                     <span className="first-page-title-left">第2步</span>
            //                     <span className="first-page-title-right">耗时60S</span>
            //                 </div>
            //                 <img className="product-detail-img" src={step1} alt="" />
            //                 <div className="product-detail-title">自由选购</div>
            //                 <div className="product-detail-tips">视觉动态识别跟踪</div>
            //                 <div className="product-detail-tips">全程伴随客服语音导购</div>
            //             </div>
            //             <div className="product-detail product-detail-page unattended-first-page">
            //                 <div className="first-page-title">
            //                     <span className="first-page-title-left">第3步</span>
            //                     <span className="first-page-title-right">耗时5S</span>
            //                 </div>
            //                 <img className="product-detail-img" src={step1} alt="" />
            //                 <div className="product-detail-title">自助收银</div>
            //                 <div className="product-detail-tips">自助收银机扫码结算</div>
            //                 <div className="product-detail-tips">支持刷脸支付</div>
            //             </div>
            //             <div className="product-detail product-detail-page unattended-first-page">
            //                 <div className="first-page-title">
            //                     <span className="first-page-title-left">第4步</span>
            //                     <span className="first-page-title-right">耗时2S</span>
            //                 </div>
            //                 <img className="product-detail-img" src={step1} alt="" />
            //                 <div className="product-detail-title">开门离店</div>
            //                 <div className="product-detail-tips">买单后自动开门</div>
            //                 <div className="product-detail-tips">智能+人工判别异常</div>
            //             </div>
                        
            //         </div>

            //     </div>

            //     <div className="common-block-home advantage-common-block-home">
            //         <div className="common-block-home-title">悦喵云值守，低成本实现无人零售</div>

            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-index">01</div>
            //                     <div className="advantage-detail-left-title">升级改造成本低</div>
            //                     <div className="advantage-detail-left-tips">全套设备仅需1-2W元，改动小、成本低！单点、连锁店均可用，适用于99%零售门店</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage2} alt="" />
            //                 </div>
            //             </div>
                        
            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage2} alt="" />
            //                 </div>
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-index">02</div>
            //                     <div className="advantage-detail-left-title">客服24小时看店</div>
            //                     <div className="advantage-detail-left-tips">360°全景看店，客服远程语音导购，处理紧急情况，一人同事看多店，共享人力</div>
            //                 </div>
            //             </div>
                       
            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-index">03</div>
            //                     <div className="advantage-detail-left-title">自助收银结算</div>
            //                     <div className="advantage-detail-left-tips">自带专业收银系统，人工收银+自助结算模式随时切换，5s完成子结算，零操作门槛。</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage3} alt="" />
            //                 </div>
            //             </div>
                       
            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style4" src={advantage4} alt="" />
            //                     <img className="member-img-style4" src={advantage4} alt="" />
            //                 </div>
            //                 <div className="advantage-detail-left">
            //                     <div style={{ display: 'flex', alignItems: 'center' }}>
            //                         <div className="advantage-detail-left-index">04</div>
            //                         <div className="advantage-detail-left-title">有人+无人模式切换</div>
            //                     </div>
            //                     <div className="advantage-detail-left-tips">门店根据经营需求，可手动切换模式，亦可设置不同时段自动切换。</div>
            //                 </div>
            //             </div>
                        
            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-index">05</div>
            //                     <div className="advantage-detail-left-title">科学数据报表</div>
            //                     <div className="advantage-detail-left-tips">门店自控数据更安全，线上线下数据全方位留存，优化导购服务，助力科学决策。</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage5} alt="" />
            //                 </div>
            //             </div>
                        
            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div style={{ display: 'flex',alignItems: 'center' }}>
            //                         <div className="advantage-detail-left-index">06</div>
            //                         <div className="advantage-detail-left-title">更多智能细节</div>
            //                     </div>
            //                     <div className="advantage-detail-left-tips">多重智能系统，全方位保障“云值守”期间门店的高效运营，给顾客更美好的线下购物体验</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <div className="advantage-detail-right-page">
            //                         <img className="advantage-more-detaill-img" src={intelligent1} alt="" />
            //                         <div className="advantage-more-detaill-title">智能监控防盗系统</div>
            //                         <div className="advantage-more-detaill-tips">360°全景智能摄像头云看店，智能+人工</div>
            //                         <div className="advantage-more-detaill-tips">综合防盗更安全！</div>
            //                     </div>
            //                     <div className="advantage-detail-right-page">
            //                         <img className="advantage-more-detaill-img" src={intelligent1} alt="" />
            //                         <div className="advantage-more-detaill-title">UPS控电控网系统</div>
            //                         <div className="advantage-more-detaill-tips">UPS多端口控制各路硬件电源/网络，临时断电断网也不担心！</div>
            //                         <div className="advantage-more-detaill-tips"> </div>
            //                     </div>
            //                     <div className="advantage-detail-right-page">
            //                         <img className="advantage-more-detaill-img" src={intelligent1} alt="" />
            //                         <div className="advantage-more-detaill-title">智能灯控系统</div>
            //                         <div className="advantage-more-detaill-tips">智能灯控开关介入云值守智能终端，可同时控制店铺多路灯，灵活又环保</div>
            //                         <div className="advantage-more-detaill-tips" > </div>
            //                     </div>
            //                 </div>
            //             </div>
                        
            //         </div>

            //     </div>

               


                
            // </div >
        )
    }
}


export default Unattended